var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "EmptyModal",
        { attrs: { modalData: _vm.modalData, onModalClose: _vm.closeModal } },
        [
          _vm._t("default", function () {
            return [
              _c("div", { staticClass: "text-left" }, [
                _c(
                  "div",
                  { staticClass: "text-center m-b-5" },
                  [
                    _c("VuePhoneNumberInput", {
                      attrs: {
                        translations: _vm.translations,
                        "default-country-code": "RU",
                        "preferred-countries": ["RU", "BY", "UA"],
                      },
                      on: { update: _vm.updateClientPhone },
                      model: {
                        value: _vm.dialNumber,
                        callback: function ($$v) {
                          _vm.dialNumber = $$v
                        },
                        expression: "dialNumber",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                false
                  ? _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        !_vm.$userPhoneNumbers ||
                        !_vm.$userPhoneNumbers.availablePhones ||
                        !Object.keys(_vm.$userPhoneNumbers.availablePhones)
                          .length
                          ? [
                              _c("h4", [
                                _vm._v(
                                  "У Вас нет активных номеров, обратитесь к администратору"
                                ),
                              ]),
                            ]
                          : _vm._l(
                              _vm.$userPhoneNumbers.availablePhones,
                              function (project, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "phone_block" },
                                  [
                                    _c("h5", [
                                      _vm._v(
                                        _vm._s(_vm.$AllProjects[index].name)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("h5", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.userPhones[index] &&
                                              _vm.userPhones[index][0] &&
                                              _vm.$userPhoneNumbers
                                                .availableSip[
                                                _vm.userPhones[index][0]
                                                  .mango_acc_id
                                              ].sip_login
                                          ) +
                                          "\n              "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "draggable",
                                      {
                                        attrs: { tag: "div" },
                                        on: { update: _vm.updateOrder },
                                        model: {
                                          value: _vm.userPhones[index],
                                          callback: function ($$v) {
                                            _vm.$set(_vm.userPhones, index, $$v)
                                          },
                                          expression: "userPhones[index]",
                                        },
                                      },
                                      [
                                        _c(
                                          "transition-group",
                                          {
                                            attrs: {
                                              type: "transition",
                                              name: "flip-list",
                                            },
                                          },
                                          _vm._l(
                                            _vm.userPhones[index],
                                            function (phone) {
                                              return _c(
                                                "div",
                                                {
                                                  key: phone.id,
                                                  staticClass: "phone_group",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "icon-fa icon-fa-arrows pointer",
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "vue-ladda",
                                                    {
                                                      attrs: {
                                                        "button-class":
                                                          "btn btn-success btn-xs phoneCall_btn",
                                                        "data-style": "zoom-in",
                                                        loading: phone.loading,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.makePhoneCall(
                                                            phone
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "icon-fa icon-fa-phone-square",
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        phone.line_number
                                                      ) +
                                                      " (" +
                                                      _vm._s(
                                                        phone.phone_title
                                                      ) +
                                                      ")\n                  "
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                        _vm._v(" "),
                        _c("div", { staticClass: "p-l-10" }, [
                          _c("h5", [_vm._v("История звонков")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "phone_history_block" }, [
                            _vm.downloadingHistory
                              ? _c(
                                  "div",
                                  [
                                    _c("pulse-loader", {
                                      staticClass: "text-center",
                                      attrs: {
                                        loading: _vm.downloadingHistory,
                                        color: _vm.loadingColor,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  [
                                    !_vm.historyRecords.length
                                      ? [
                                          _c("p", [
                                            _vm._v("Звонков не найдено!"),
                                          ]),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.historyRecords,
                                      function (record) {
                                        return _c(
                                          "div",
                                          {
                                            key: record.id,
                                            staticClass: "history_phone_record",
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    record.phoneData
                                                      ? _vm.$AllProjects[
                                                          record.phoneData
                                                            .project_id
                                                        ].name +
                                                          " (" +
                                                          _vm.$AllCities[
                                                            record.phoneData
                                                              .city_id
                                                          ].short_name +
                                                          ")"
                                                      : "Не определено направление"
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("p", [
                                              _c("i", {
                                                class: {
                                                  "icon-fa": true,
                                                  "icon-fa-arrow-circle-left green":
                                                    record.type_id === 1,
                                                  "icon-fa-arrow-circle-right blue":
                                                    record.type_id === 2,
                                                },
                                              }),
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    record.phone_title ||
                                                      "не определен"
                                                  ) +
                                                  " =>\n                      " +
                                                  _vm._s(record.destination) +
                                                  "\n                    "
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            record.showRecord
                                              ? _c("div", [
                                                  record.audio_record_id
                                                    ? _c(
                                                        "audio",
                                                        {
                                                          attrs: {
                                                            controls: "",
                                                          },
                                                        },
                                                        [
                                                          _c("source", {
                                                            attrs: {
                                                              src: `https://admin.rancond.info/api/noa/mangoRecord/${record.id}`,
                                                              type: "audio/mpeg",
                                                            },
                                                          }),
                                                          _vm._v(
                                                            "\n                        Your browser does not support the audio tag.\n                      "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex justify-content-between",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  [
                                                    record.order_id
                                                      ? [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn-info btn-xs",
                                                              attrs: {
                                                                type: "button",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.loadOrder(
                                                                      record.order_id
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    record.order_id
                                                                  ) +
                                                                  "\n                          "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    !record.showRecord &&
                                                    record.file_link
                                                      ? [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn-success btn-xs",
                                                              attrs: {
                                                                type: "button",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    record.showRecord = true
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            Показать запись звонка\n                          "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "text-muted" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(record.created_at)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                          ]),
                        ]),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex flex-wrap" },
                  [
                    !_vm.$userPhoneNumbers ||
                    !_vm.$userPhoneNumbers.availableSip
                      ? [
                          _c("h4", [
                            _vm._v(
                              "У Вас нет активных номеров, обратитесь к администратору"
                            ),
                          ]),
                        ]
                      : _vm._l(
                          _vm.$userPhoneNumbers.availableSip,
                          function (sip, index) {
                            return _c("div", { staticClass: "phone_block" }, [
                              _vm.phonesOrder[sip.acc_id] &&
                              _vm.phonesOrder[sip.acc_id][0]
                                ? _c("p", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          (_vm.$AllProjects[
                                            _vm.phonesOrder[sip.acc_id][0]
                                              .connected_phone.site_id
                                          ] &&
                                            _vm.$AllProjects[
                                              _vm.phonesOrder[sip.acc_id][0]
                                                .connected_phone.site_id
                                            ].name) ||
                                            "не указано имя"
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("p", [_vm._v(_vm._s(sip.sip_login))]),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c(
                                    "draggable",
                                    {
                                      attrs: { tag: "div" },
                                      on: {
                                        update: function ($event) {
                                          return _vm.updateOrderList(sip.acc_id)
                                        },
                                      },
                                      model: {
                                        value: _vm.phonesOrder[sip.acc_id],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.phonesOrder,
                                            sip.acc_id,
                                            $$v
                                          )
                                        },
                                        expression: "phonesOrder[sip.acc_id]",
                                      },
                                    },
                                    [
                                      _c(
                                        "transition-group",
                                        {
                                          attrs: {
                                            type: "transition",
                                            name: "flip-list",
                                          },
                                        },
                                        _vm._l(
                                          _vm.phonesOrder[sip.acc_id],
                                          function (phone) {
                                            return _c(
                                              "div",
                                              {
                                                key: phone.id,
                                                staticClass: "phone_group",
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "icon-fa icon-fa-arrows pointer",
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "vue-ladda",
                                                  {
                                                    attrs: {
                                                      "button-class":
                                                        "btn btn-success btn-xs phoneCall_btn",
                                                      "data-style": "zoom-in",
                                                      loading: phone.loading,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.makePhoneCall2(
                                                          phone.connected_phone,
                                                          sip
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "icon-fa icon-fa-phone-square",
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      phone.connected_phone
                                                        .display_phone
                                                    ) +
                                                    " (" +
                                                    _vm._s(
                                                      phone.connected_phone
                                                        .description
                                                    ) +
                                                    ")\n                    "
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ])
                          }
                        ),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-l-10" }, [
                      _c("h5", [_vm._v("История звонков")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "phone_history_block" }, [
                        _vm.downloadingHistory
                          ? _c(
                              "div",
                              [
                                _c("pulse-loader", {
                                  staticClass: "text-center",
                                  attrs: {
                                    loading: _vm.downloadingHistory,
                                    color: _vm.loadingColor,
                                  },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              [
                                !_vm.historyRecords.length
                                  ? [_c("p", [_vm._v("Звонков не найдено!")])]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.historyRecords, function (record) {
                                  return _c(
                                    "div",
                                    {
                                      key: record.id,
                                      staticClass: "history_phone_record",
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              record.phoneData
                                                ? _vm.$AllProjects[
                                                    record.phoneData.project_id
                                                  ].name +
                                                    " (" +
                                                    _vm.$AllCities[
                                                      record.phoneData.city_id
                                                    ].short_name +
                                                    ")"
                                                : "Не определено направление"
                                            ) +
                                            "\n                    "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _c("i", {
                                          class: {
                                            "icon-fa": true,
                                            "icon-fa-arrow-circle-left green":
                                              record.type_id === 1,
                                            "icon-fa-arrow-circle-right blue":
                                              record.type_id === 2,
                                          },
                                        }),
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              record.phone_title ||
                                                "не определен"
                                            ) +
                                            " =>\n                      " +
                                            _vm._s(record.destination) +
                                            "\n                    "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      record.showRecord
                                        ? _c("div", [
                                            record.audio_record_id
                                              ? _c(
                                                  "audio",
                                                  { attrs: { controls: "" } },
                                                  [
                                                    _c("source", {
                                                      attrs: {
                                                        src: `https://admin.rancond.info/api/noa/mangoRecord/${record.id}`,
                                                        type: "audio/mpeg",
                                                      },
                                                    }),
                                                    _vm._v(
                                                      "\n                        Your browser does not support the audio tag.\n                      "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex justify-content-between",
                                        },
                                        [
                                          _c(
                                            "span",
                                            [
                                              record.order_id
                                                ? [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-info btn-xs",
                                                        attrs: {
                                                          type: "button",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.loadOrder(
                                                              record.order_id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            " +
                                                            _vm._s(
                                                              record.order_id
                                                            ) +
                                                            "\n                          "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !record.showRecord &&
                                              record.file_link
                                                ? [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-success btn-xs",
                                                        attrs: {
                                                          type: "button",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            record.showRecord = true
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            Показать запись звонка\n                          "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "text-muted" },
                                            [_vm._v(_vm._s(record.created_at))]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            ),
                      ]),
                    ]),
                  ],
                  2
                ),
              ]),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }